import { ROOT_CONSTANT } from "../../constants";

const {
  icon_bank_affin,
  icon_bank_agro,
  icon_bank_alliance,
  icon_bank_alrajhi,
  icon_bank_ambank,
  icon_bank_america,
  icon_bank_bsn,
  icon_bank_chartered,
  icon_bank_chase,
  icon_bank_china,
  icon_bank_china_commersial,
  icon_bank_cimb,
  icon_bank_cimb_islamic,
  icon_bank_citi,
  icon_bank_duetsche,
  icon_bank_hong_leong,
  icon_bank_hsbc,
  icon_bank_hsbc_amanah,
  icon_bank_islam,
  icon_bank_kuwait,
  icon_bank_maybank,
  icon_bank_maybank_islamic,
  icon_bank_mizuho,
  icon_bank_muamalat,
  icon_bank_ocbc,
  icon_bank_paribas,
  icon_bank_public,
  icon_bank_rakyat,
  icon_bank_sumitomo,
  icon_bank_tokyo,
  icon_bank_uob,
  icon_bank_rhb,
} = ROOT_CONSTANT.IMG.ICON.BANK;

const {
  icon_malaysia
} = ROOT_CONSTANT.IMG.ICON.COUNTRY


const BankImg = ({ iconBank }) => (
  <img
    src={iconBank}
    alt="bank"
    style={{
      width: "18px",
      height: "18px",
      marginRight: "5px",
      verticalAlign: "middle",
    }}
  />
);

const CountryImg = ({ iconCountry }) => (
  <img
    src={iconCountry}
    alt="Country"
    style={{
      width: "15px",
      height: "15px",
      // verticalAlign: "middle",
      marginRight: "5px",
    }}
  />
);

export const bankList = [
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_affin} />
        Affin Bank BHD
      </span>
    ),
    value: { name: "Affin", bank_code: "PHBMMYKL" },
    icon: <BankImg iconBank={icon_bank_affin} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_affin} />
        Affin Islamic Bank BHD
      </span>
    ),
    value: { name: "Affin Islamic", bank_code: "AIBBMYKL" },
    icon: <BankImg iconBank={icon_bank_affin} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_agro} />
        Agro Bank
      </span>
    ),
    value: { name: "Agro", bank_code: "AGOBMYKL" },
    icon: <BankImg iconBank={icon_bank_agro} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_alrajhi} />
        Al-Rajhi Bank
      </span>
    ),
    value: { name: "Al-Rajhi", bank_code: "RJHIMYKL" },
    icon: <BankImg iconBank={icon_bank_alrajhi} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_alliance} />
        Alliance Bank
      </span>
    ),
    value: { name: "Alliance", bank_code: "MFBBMYKL" },
    icon: <BankImg iconBank={icon_bank_alliance} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_alliance} />
        Alliance Islamic Bank
      </span>
    ),
    value: { name: "Alliance Islamic", bank_code: "ALSRMYKL" },
    icon: <BankImg iconBank={icon_bank_alliance} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_ambank} />
        Ambank
      </span>
    ),
    value: { name: "Ambank", bank_code: "ARBKMYKL" },
    icon: <BankImg iconBank={icon_bank_ambank} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_ambank} />
        Amislamic Bank
      </span>
    ),
    value: { name: "Amislamic", bank_code: "AISLMYKL" },
    icon: <BankImg iconBank={icon_bank_ambank} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_china} />
        Bank of China (Malaysia) Berhad
      </span>
    ),
    value: { name: "BOC", bank_code: "BKCHMYKL" },
    icon: <BankImg iconBank={icon_bank_china} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_tokyo} />
        Bank of Tokyo
      </span>
    ),
    value: { name: "BOT", bank_code: "BOTKMYKX" },
    icon: <BankImg iconBank={icon_bank_tokyo} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_bsn} />
        Bank Simpanan Nasional
      </span>
    ),
    value: { name: "Simpanan Nasional", bank_code: "BSNAMYK1" },
    icon: <BankImg iconBank={icon_bank_bsn} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_bsn} />
        Bank Simpanan Nasional - SPI
      </span>
    ),
    value: { name: "Simpanan Nasional SPI", bank_code: "BSNAMY21" },
    icon: <BankImg iconBank={icon_bank_bsn} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_paribas} />
        BNP Paribas Malaysia Berhad
      </span>
    ),
    value: { name: "BNP Paribas", bank_code: "BNPAMYKL" },
    icon: <BankImg iconBank={icon_bank_paribas} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_islam} />
        Bank Islam
      </span>
    ),
    value: { name: "Islam", bank_code: "BIMBMYKL" },
    icon: <BankImg iconBank={icon_bank_islam} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_muamalat} />
        Bank Mualamat
      </span>
    ),
    value: { name: "Mualamat", bank_code: "BMMBMYKL" },
    icon: <BankImg iconBank={icon_bank_muamalat} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_rakyat} />
        Bank Rakyat
      </span>
    ),
    value: { name: "Rakyat", bank_code: "BKRMMYKL" },
    icon: <BankImg iconBank={icon_bank_rakyat} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_america} />
        Bank of America (Malaysia) Berhad
      </span>
    ),
    value: { name: "BOA", bank_code: "BOFAMY2X" },
    icon: <BankImg iconBank={icon_bank_america} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_cimb} />
        CIMB Bank Berhad
      </span>
    ),
    value: { name: "CIMB", bank_code: "CIBBMYKL" },
    icon: <BankImg iconBank={icon_bank_cimb} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_cimb_islamic} />
        CIMB Islamic Bank Berhad
      </span>
    ),
    value: { name: "CIMB Islamic", bank_code: "CTBBMYKL" },
    icon: <BankImg iconBank={icon_bank_cimb_islamic} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_citi} />
        Citibank
      </span>
    ),
    value: { name: "Citibank", bank_code: "CITIMYKL" },
    icon: <BankImg iconBank={icon_bank_citi} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_citi} />
        Citibank - SPI
      </span>
    ),
    value: { name: "Citibank SPI", bank_code: "CITIMYM1" },
    icon: <BankImg iconBank={icon_bank_citi} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_duetsche} />
        Deutsche Bank - SPI
      </span>
    ),
    value: { name: "Deutsche SPI", bank_code: "DEUTMY21" },
    icon: <BankImg iconBank={icon_bank_duetsche} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_duetsche} />
        Deutsche Bank (Malaysia) Berhad
      </span>
    ),
    value: { name: "Deutsche", bank_code: "DEUTMYKL" },
    icon: <BankImg iconBank={icon_bank_duetsche} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_hong_leong} />
        Hong Leong Bank
      </span>
    ),
    value: { name: "Hong Leong", bank_code: "HLBBMYKL" },
    icon: <BankImg iconBank={icon_bank_hong_leong} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_hong_leong} />
        Hong Leong Islamic Bank BHD
      </span>
    ),
    value: { name: "Hong Leong Islamic", bank_code: "HLIBMYKL" },
    icon: <BankImg iconBank={icon_bank_hong_leong} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_hsbc} />
        HSBC Bank
      </span>
    ),
    value: { name: "HSBC", bank_code: "HBMBMYKL" },
    icon: <BankImg iconBank={icon_bank_hsbc} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_hsbc_amanah} />
        HSBC Amanah Malaysia BHD
      </span>
    ),
    value: { name: "HSBC Amanah", bank_code: "HMABMYKL" },
    icon: <BankImg iconBank={icon_bank_hsbc_amanah} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_china_commersial} />
        Industrial & Commersial Bank of China
      </span>
    ),
    value: { name: "Industrial BOC", bank_code: "ICBKMYKL" },
    icon: <BankImg iconBank={icon_bank_china_commersial} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_chase} />
        J.P.Morgan Chase Bank Berhad
      </span>
    ),
    value: { name: "J.P.Morgan Chase", bank_code: "CHASMYKX" },
    icon: <BankImg iconBank={icon_bank_chase} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_kuwait} />
        Kuwait Finance House (Malaysia) Berhad
      </span>
    ),
    value: { name: "Kuwait Finance", bank_code: "KFHOMYKL" },
    icon: <BankImg iconBank={icon_bank_kuwait} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_maybank_islamic} />
        Maybank Islamic BHD
      </span>
    ),
    value: { name: "Maybank Islamic", bank_code: "MBISMYKL" },
    icon: <BankImg iconBank={icon_bank_maybank_islamic} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_mizuho} />
        Mizuho Corporate Bank (Malaysia) Berhad
      </span>
    ),
    value: { name: "Mizuho Corporate", bank_code: "MHCBMYKA" },
    icon: <BankImg iconBank={icon_bank_mizuho} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_maybank} />
        Maybank
      </span>
    ),
    value: { name: "Maybank", bank_code: "MBBEMYKL" },
    icon: <BankImg iconBank={icon_bank_maybank} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_ocbc} />
        OCBC Bank
      </span>
    ),
    value: { name: "OCBC", bank_code: "OCBCMYKL" },
    icon: <BankImg iconBank={icon_bank_ocbc} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_ocbc} />
        OCBC Al-Amin Bank BHD
      </span>
    ),
    value: { name: "OCBC Al-Amin", bank_code: "OABBMYKL" },
    icon: <BankImg iconBank={icon_bank_ocbc} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_public} />
        Public Islamic Bank BHD
      </span>
    ),
    value: { name: "Public Islamic", bank_code: "PIBEMYK1" },
    icon: <BankImg iconBank={icon_bank_public} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_public} />
        Public Bank
      </span>
    ),
    value: { name: "Public", bank_code: "PBBEMYKL" },
    icon: <BankImg iconBank={icon_bank_public} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_rhb} />
        RHB Bank Berhad
      </span>
    ),
    value: { name: "RHB Berhad", bank_code: "RHBBMYKL" },
    icon: <BankImg iconBank={icon_bank_rhb} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_rhb} />
        RHB Islamic Bank BHD
      </span>
    ),
    value: { name: "RHB Islamic", bank_code: "RHBAMYKL" },
    icon: <BankImg iconBank={icon_bank_rhb} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_chartered} />
        Standard Chartered Saadiq BHD
      </span>
    ),
    value: { name: "Chartered Saadiq", bank_code: "SCSRMYKK" },
    icon: <BankImg iconBank={icon_bank_chartered} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_chartered} />
        Standard Chartered Bank
      </span>
    ),
    value: { name: "Chartered", bank_code: "SCBLMYKX" },
    icon: <BankImg iconBank={icon_bank_chartered} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_sumitomo} />
        Sumitomo Mitsui Banking Corp MSIA Berhad
      </span>
    ),
    value: { name: "Sumitomo Mitsui", bank_code: "SMBCMYKL" },
    icon: <BankImg iconBank={icon_bank_sumitomo} />
  },
  {
    label: (
      <span>
        <BankImg iconBank={icon_bank_uob} />
        United Overseas Bank Berhad
      </span>
    ),
    value: { name: "United Overseas", bank_code: "UOVBMYKL" },
    icon: <BankImg iconBank={icon_bank_uob} />
  }
];


export const countryList = [
  {
    label: (
      <span>
        +60
      </span>
    ),
    value: "+60",
    imgSrc: <CountryImg iconCountry={icon_malaysia} />
  },
  {
    label: (
      <span>
        +62
      </span>
    ),
    value: "+62",
    imgSrc: <CountryImg iconCountry={icon_malaysia} />
  },
];

export const companyTypeList = [
  {
    label: "Sendirian Berhad (Sdn Bhd)",
    value: "Sendirian Berhad (Sdn Bhd)",
  },
  {
    label: "Berhad (Bhd)",
    value: "Berhad",
  },
  {
    label: "Sole Proprietorship",
    value: "Sole Proprietorship",
  },
  {
    label: "Partnership",
    value: "Partnership",
  },
  {
    label: "Limited Liability Partnership (LLP)",
    value: "Limited Liability Partnership (LLP)",
  },
];

export const stateList = [
  { value: "Johor", label: "Johor" },
  { value: "Kedah", label: "Kedah" },
  { value: "Kelantan", label: "Kelantan" },
  { value: "Kuala Lumpur", label: "Kuala Lumpur" },
  { value: "Labuan", label: "Labuan" },
  { value: "Melaka", label: "Melaka" },
  { value: "Negeri Sembilan", label: "Negeri Sembilan" },
  { value: "Pahang", label: "Pahang" },
  { value: "Perak", label: "Perak" },
  { value: "Perlis", label: "Perlis" },
  { value: "Pulau Pinang", label: "Pulau Pinang" },
  { value: "Sabah", label: "Sabah" },
  { value: "Sarawak", label: "Sarawak" },
  { value: "Selangor", label: "Selangor" },
  { value: "Terengganu", label: "Terengganu" },
];
